
export default {
  data() {
    return {
      pageData: null,
      inView: false,
      tutorials: null,
      categories: [],
      selectedCategory: null,
      selectedTutorial: null,
      dropdownOpen: false,
      selectedTutorialTitle: null,
    };
  },
  watch: {
    selectedTutorial() {
      this.$router.push(this.selectedTutorial);
    },
    selectedCategory() {
      this.changeCategory();
    },
  },
  mounted() {
    this.getPageData();
    this.getTutorials();
    this.getCategories();
  },
  methods: {
    changeCategory() {
      this.$router.push({
        query: { category: this.selectedCategory },
      });
    },
    getPageData() {
      this.pageData = this.$parent.$parent.pageData;
      this.selectedTutorial = this.pageData.slug;
      this.selectedTutorialTitle = this.pageData.title;
    },
    async getCategories() {
      this.categories = await this.$getCategoriesInGroup("Tutorials");
    },
    async getTutorials() {
      this.loading = true;
      this.tutorials = await this.$getCustomPost(
        "tutorials",
        ["Tutorials"],
        6,
        1
      );
      this.loading = false;
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
  },
};
